import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=d7280944&scoped=true"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=d7280944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7280944",
  null
  
)

export default component.exports